import { KEY_TOKEN_API } from "Shared/Constant/Cache";
import * as LocalVariableUtil from 'Shared/Utils/LocalVariable/index';
const getTokenAPI = (key?: string) => {
  let _token = LocalVariableUtil.get(KEY_TOKEN_API);
  return _token;
};

export default getTokenAPI;